module.exports = __webpack_public_path__ + "static/media/banner_worliMatkaVR-half.2ac5eb43.png";